import axios from "axios";
import { API_AUTH_URL, API_BACKEND_URL } from "../constants/consts";
import { getExchangeHeaders } from "./helpers";
import { getSession } from "./sessionManagement";

const HEALTHCHECK_TIMEOUT_MS = 5000;

export interface ServiceProbeResult {
  isAvailable: boolean;
  status: number | null;
}

export async function probeAuthAvailability(): Promise<ServiceProbeResult> {
  try {
    const response = await axios.post(
      `${API_AUTH_URL}/users/check`,
      {
        session_id: getSession(),
      },
      {
        timeout: HEALTHCHECK_TIMEOUT_MS,
        validateStatus: () => true,
      }
    );

    return {
      status: response.status,
      isAvailable: response.status < 500,
    };
  } catch {
    return {
      status: null,
      isAvailable: false,
    };
  }
}

export async function probeCoreBackendAvailability(): Promise<ServiceProbeResult> {
  try {
    const response = await axios.get(
      `${API_BACKEND_URL}/categories/landing_categories`,
      {
        headers: getExchangeHeaders(),
        timeout: HEALTHCHECK_TIMEOUT_MS,
        validateStatus: () => true,
      }
    );

    return {
      status: response.status,
      isAvailable: response.status >= 200 && response.status < 300,
    };
  } catch {
    return {
      status: null,
      isAvailable: false,
    };
  }
}
